import pluralize from 'pluralize';

const YEARS_MS = 1000 * 60 * 60 * 24 * 365;
const DAYS_MS = 1000 * 60 * 60 * 24;
const HOURS_MS = 1000 * 60 * 60;
const MINUTES_MS = 1000 * 60;
const SECONDS_MS = 1000;

export const humanizeMs = (ms) => {
  const years = Math.floor(ms / YEARS_MS);

  if (years > 0) {
    const yearsRemainderMs = ms % YEARS_MS;
    const days = Math.floor(yearsRemainderMs / DAYS_MS);

    return `${pluralize('year', years, true)}, ${pluralize('day', days, true)}`;
  }

  const days = Math.floor(ms / DAYS_MS);
  if (days > 0) {
    const daysRemainderMs = ms % DAYS_MS;
    const hours = Math.floor(daysRemainderMs / HOURS_MS);

    return `${pluralize('day', days, true)}, ${pluralize('hour', hours, true)}`;
  }

  const hours = Math.floor(ms / HOURS_MS);
  if (hours > 0) {
    const hoursRemainderMs = ms % HOURS_MS;
    const minutes = Math.floor(hoursRemainderMs / MINUTES_MS);

    return `${pluralize('hour', hours, true)}, ${pluralize('minute', minutes, true)}`;
  }

  const minutes = Math.floor(ms / MINUTES_MS);
  if (minutes > 0) {
    const minutesRemainderMs = ms % MINUTES_MS;
    const seconds = Math.floor(minutesRemainderMs / SECONDS_MS);

    return `${pluralize('minute', minutes, true)}, ${pluralize('second', seconds, true)}`;
  }

  const seconds = Math.floor(ms / SECONDS_MS);
  if (seconds > 0) {
    return pluralize('second', seconds, true);
  }

  return 'less than a second';
};
